<template>
  <div style="height: 100%; width: 100%;">
    <div style="position: relative; width: 100%; height: 100%; background-color: transparent !important;" class="d-flex align-center justify-center">
      <div style="position: absolute; top: 10%; right: 0; bottom: 0; left: 10%; transition-duration: 1s; background-color: transparent !important; width: 80%; height: 75%;" 
        :style="showCloudProgress && cloudProgress? cloudProgressStyle : {}" v-if="dataState === 'ready'">
        <vue-word-cloud class="cloud" :progress.sync="cloudProgress" :words="cloudWords" :color="cloudColors" :spacing=1 :fontSizeRatio=5>
          <template slot-scope="word">
            <v-tooltip top>
              <div slot="activator" style="cursor: pointer;" @click="entityFilter(word.text)">{{ word.text }}</div>
              <div style="text-align: center;">{{ word.text }}<br/>({{ word.weight }})</div>
            </v-tooltip>
          </template>				
        </vue-word-cloud>
      </div>
      <template v-else-if="dataState === 'loading'">
        <center>
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
			  <v-progress-circular v-if="showCloudProgress && cloudProgress" 
			    style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto; background-color: transparent !important;"
			    :value="(cloudProgress.completedWords / cloudProgress.totalWords) * 100"
			    :size="150"
			    :width="10" 
			    :rotate="-90">
			    {{ cloudProgress.completedWords }} of {{ cloudProgress.totalWords }}
			  </v-progress-circular>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import VueWordCloud from 'vuewordcloud'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      showCloudProgress: false,
      cloudProgress: null,
      cloudData: [],
      minValue: Number.MAX_VALUE,
      maxValue: Number.MIN_VALUE
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getEntity']),
    filterEntity: function () {
      return this.getEntity
    },
    cloudProgressStyle: function () {
      return {
        pointerEvents: 'none',
        opacity: 0.3,
        transform: 'scale(0.7, 0.7)',
        'background-color': 'transparent'
      }
    },
    cloudWords: function () {
      return this.cloudData
    },
    cloudColors: function () {
      return ([, weight]) => {
        let range = this.maxValue - this.minValue
        let bucket = range / 5
        if (weight > this.maxValue - bucket) {
          return '#0099ff'
        } else if (weight > this.maxValue - 2 * bucket) {
          return '#3399ff'
        } else if (weight > this.maxValue - 3 * bucket) {
          return '#99ccff'
        } else if (weight > this.maxValue - 4 * bucket) {
          return '#9999ff'
        } else {
          return '#999966'
        }
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters', 'resetEntityFilter']),
    entityFilter: function (word) {
      this.showCloudProgress = true
      var filter = this.filterEntity.slice()
      var index = filter.indexOf(word)
      if (index >= 0) {
        filter.splice(index, 1)
        this.setCustomFilters({entity: filter})
      } else {
        filter.push(word)
        this.setCustomFilters({entity: filter})
      }
    },
    getData: function () {
      this.dataState = 'loading'
      this.showCloudProgress = false
      axios.all([
        this.$store.dispatch('getEntitiesCount', this.getQuery({pageSize: 50, sortBy: '_count', excludeRelatedEntities: true, order: 'DESC'}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let temp = []
          for (var i = 0; i < r1.data.payload.length; i++) {
            temp.push([r1.data.payload[i]._name, r1.data.payload[i]._count])
            if (Number(r1.data.payload[i]._count) < this.minValue) {
              this.minValue = Number(r1.data.payload[i]._count)
            }
            if (Number(r1.data.payload[i]._count) > this.maxValue) {
              this.maxValue = Number(r1.data.payload[i]._count)
            }
          }
          this.cloudData = temp
          if (r1.data.payload.length > 0) {
            this.showCloudProgress = true
            this.dataState = 'ready'
          } else {
            this.showCloudProgress = false
            this.dataState = 'noData'
          }
        } else {
          this.cloudData = []
          this.showCloudProgress = false
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.cloudData = []
        this.showCloudProgress = false
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    cloudProgress: function (currentCloudProgress, previousCloudProgress) {
      this.showCloudProgress = !previousCloudProgress
    }
  },
  components: {
    [VueWordCloud.name]: VueWordCloud
  }
}
</script>



// WEBPACK FOOTER //
// src/components/clouds/EntityCloud.vue